import Link from "next/link";
import { StepNavigationProps } from "./StepNavigation.interfaces"
import { StepNavigationMenuItem } from "./StepNavigationMenuItem";
import { getValidClassNames } from "@/utils";
import { useEffect, useState } from "react";
import { isMenuItemDisabled } from "./StepNavigation.helpers";
import { useRouter } from "next/router";
import { useMediaQuery } from "@/hooks";

export const StepNavigation = ({ baseUrl, contentPages, currentPageId, shouldCloseOnNavigate }: StepNavigationProps) => {
  const router = useRouter();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);

  const isOverlap = useMediaQuery({ customQuery: '(min-width: 1600px)' });
  
  const toggleMenu = (isToggle: boolean) => {
    setIsMenuOpen(isToggle)
  };

  useEffect(() => {
    toggleMenu(isOverlap)
  }, [isOverlap]);

  useEffect(() => {
    if(isOverlap) return;

    if(shouldCloseOnNavigate) {
      toggleMenu(false)
    }
  }, [router, isOverlap])

  return(
    <aside 
      className={getValidClassNames({
        "absolute h-full w-11/12 max-w-64 bg-white border-r border-grey-400 z-10 left-0 transition-200 shadow-xl": true,
        '-translate-x-100': !isMenuOpen
      })}
    >
      <button 
        className="absolute right-0 translate-x-100 flex items-center jutisfy-center p-2 rounded-r bg-black pointer"
        onClick={() => toggleMenu(!isMenuOpen)}
      >
        <span className="sr-only">
          {`${isMenuOpen ? 'Open' : 'Close'} menu`}
        </span>
        <div className={getValidClassNames({
          "flex items-center jutisfy-center rounded-circle p-1": true,
          "bg-red-400 color-white": isMenuOpen,
          "bg-primary color-bloack": !isMenuOpen,
        })}>
          {isMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          )}
        </div>
      </button>

      <div className="overflow-y-auto h-full">
        <Link 
          className="flex color-black text-sm text-decoration-none px-2 py-4 border-b border-grey-400" 
          href='/dashboard'
        >
          Dashboard
        </Link>

        <nav aria-label='Module navigation' className="p-2">
          <ol className='list-style-none m-0 flex flex-col'>
            {contentPages.map(({ contentPageChildren, id, title, url }) => {
              return (
                <StepNavigationMenuItem
                  key={id}
                  baseUrl={baseUrl}
                  contentPages={contentPages}
                  contentPageChildren={contentPageChildren}
                  currentPageId={currentPageId}
                  id={id}
                  title={title}
                  url={url}
                  isDisabled={isMenuItemDisabled(id, currentPageId, contentPages)}
                />
              );
            })}
          </ol>
        </nav>
      </div>
    </aside>
  )
};